import { render, staticRenderFns } from "./member-order-upgrade.component.vue?vue&type=template&id=440021bf"
import script from "./member-order-upgrade.component.vue?vue&type=script&lang=js"
export * from "./member-order-upgrade.component.vue?vue&type=script&lang=js"
import style0 from "./member-order-upgrade.component.vue?vue&type=style&index=0&id=440021bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports